module.exports = __webpack_public_path__ + "static/media/sweat.c44ad8b1.svg";